import React from 'react';

const ConditionsDataContext = React.createContext('conditionsData');

export const withConditionsData = (Component) => {
  return (props) => {
    return 'ConditionsDataContext', (
      <ConditionsDataContext.Consumer>
        { (conditionsData) =>
          <Component {...props} conditionsData={conditionsData} />
        }
      </ConditionsDataContext.Consumer>
    );
  };
};

export default ConditionsDataContext;
